import OLScaleLine from "ol/control/ScaleLine";
import OLMap from "ol/Map";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
const propTypes = {
  /**
   * ol/map.
   */
  map: PropTypes.instanceOf(OLMap).isRequired,
  /**
   * Options for ol/control/ScaleLine.
   * See https://openlayers.org/en/latest/apidoc/module-ol_control_ScaleLine-ScaleLine.html
   */
  options: PropTypes.object
};
const defaultProps = {
  options: {}
};
function ScaleLine({ map, options = defaultProps.options, ...other }) {
  const ref = useRef();
  useEffect(() => {
    const control = new OLScaleLine({
      ...options,
      ...{ target: ref.current }
    });
    map.addControl(control);
    return () => {
      map.removeControl(control);
    };
  }, [map, options]);
  return /* @__PURE__ */ React.createElement("div", { className: "rs-scale-line", ref, ...other });
}
ScaleLine.propTypes = propTypes;
export default React.memo(ScaleLine);
